export const ACTIVITY_ENGLISH = {
  "datox.activity.description": "A clear view of what happened, where, and who was involved.",
  "datox.activity.recentScope": "Search and filters apply to up to {{limit}} recent events you can access.",
  "datox.activity.searchLabel": "Search recent activity",
  "datox.activity.searchPlaceholder": "Search events, people, projects, or messages…",
  "datox.activity.clearSearch": "Clear search",
  "datox.activity.clearFilters": "Clear filters",
  "datox.activity.project": "Project",
  "datox.activity.allProjects": "All projects",
  "datox.activity.unavailableProject": "Selected project is no longer in recent activity",
  "datox.activity.timeRange": "Time range",
  "datox.activity.anyTime": "Any time",
  "datox.activity.lastDay": "Last 24 hours",
  "datox.activity.lastWeek": "Last 7 days",
  "datox.activity.lastMonth": "Last 30 days",
  "datox.activity.typeLabel": "Activity type",
  "datox.activity.sort": "Sort activity",
  "datox.activity.newest": "Newest first",
  "datox.activity.oldest": "Oldest first",
  "datox.activity.refreshing": "Refreshing…",
  "datox.activity.today": "Today",
  "datox.activity.yesterday": "Yesterday",
  "datox.activity.unknownDate": "Date unavailable",
  "datox.activity.loading": "Loading recent activity…",
  "datox.activity.loadFailed": "Activity couldn’t be loaded",
  "datox.activity.retryHint": "Check your connection and try again.",
  "datox.activity.retry": "Try again",
  "datox.activity.emptyTitle": "Your activity will appear here",
  "datox.activity.emptyDescription": "Changes to your projects and conversations will appear as you work.",
  "datox.activity.noMatches": "No matching activity",
  "datox.activity.noMatchesHint": "Try a different search, project, time range, or activity type.",
  "datox.activity.showing": "Showing {{shown}} of {{total}} matching events",
  "datox.activity.showMore": "Show more events",
  "datox.activity.localTime": "Times are shown in your local timezone.",
  "datox.activity.inspect": "View {{event}} by {{actor}}, {{time}}",
  "datox.activity.details": "Event details",
  "datox.activity.messageContent": "Message",
  "datox.activity.eventDescription": "Description",
  "datox.activity.noDescription": "No additional description was recorded.",
  "datox.activity.eventType": "Event type",
  "datox.activity.eventId": "Event ID",
  "datox.activity.timestamp": "Recorded at",
  "datox.activity.period": "Period",
  "datox.activity.chat": "Conversation",
  "datox.activity.actor": "Actor",
  "datox.activity.system": "System",
  "datox.activity.projectWide": "Project-wide",
  "datox.activity.workspaceEvent": "Workspace activity",
  "datox.activity.unavailable": "Not recorded",
  "datox.activity.openProject": "Open project",
  "datox.activity.copyId": "Copy event ID",
  "datox.activity.copied": "Event ID copied",
  "datox.activity.copyFailed": "Couldn’t copy. Select the event ID to copy it manually.",
  "datox.activity.role.user": "User message",
  "datox.activity.role.assistant": "Assistant response",
  "datox.activity.role.system": "System message",
  "datox.activity.role.tool": "Tool message",
} as const
